// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"5b5116f1","458":"ce455416","475":"ce455416"}[chunkId] + ".chunk.css";
};